/**
 * Product mockup used in the hero and the pricing card.
 * While empty, a code-drawn cover in the product identity is shown.
 */
export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/jwKWL1XAacqNPtepHpAavJ/Premium-hero-lifestyle-product-photo-A.png'

export const PRODUCT_MOCKUP_ALT =
  'The six spiral-bound volumes of 52 Weeks of Volleyball Practice Plans lined up on a gym floor, with a clipboard, whistle, knee pads and a team huddling with their coach behind'

export const PRODUCT_NAME = '52 Weeks of Volleyball Practice Plans'

/** Where the pricing button sends the coach. */
export const CHECKOUT_URL = 'https://52-weeks-of-volleyball-practice-plans.impultienda.ar/checkout'
